import { SVG } from '../svg';
import { IconProps } from '../types';

export function ArrowLeftIcon(props: IconProps): JSX.Element {
  return (
    <SVG {...props}>
      <path d="m12 19-7-7 7-7" />
      <path d="M19 12H5" />
    </SVG>
  );
}
